// extracted by mini-css-extract-plugin
export default {"billing_data":"Bu","delivery_details":"Cu","details_wrapper":"Eu","title":"Fu","detail_item":"Gu"};
    if(module.hot) {
      // 1743628922719
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  